import React, { useContext, useState } from 'react';
import { useForm } from "react-hook-form";
import { API, Auth } from 'aws-amplify';
import { XMarkIcon } from '@heroicons/react/24/outline';
import AppContext from '../AppContext';

const UserForm = (props) => {
  const { closeModal } = useContext(AppContext)
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [working, setWorking] = useState(false);

  const { register,  formState: { errors }, handleSubmit, setValue, trigger } = useForm();


  const validateNoDuplicates = (value) => {
    if (props.data && props?.data?.find((x) => x.email === value)) {
        return false; }
    else {
        return true };
  } 

  const createUser = async () => {
    try {
        setWorking(true);
        const myInit = {
            response: true,
            headers: { Authorization: `${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
            body: {
                "email": email,
                "password": undefined,
                "role": role,
                "firstName": firstName,
                "lastName": lastName
            }
          };

          await API.post('APIEndpoint', `/create-user`, myInit) 
          setWorking(false);
        // setToast('Success!', 'User creation succeeded!', true);
        props.refreshData && props.refreshData();
        closeModal();
    } catch(error) {
        // setToast('Failure!', 'User creation failed!', false);
        setWorking(false);
    }
  };

  const handleValidationChange = (name, value) => {
    setValue(name, value);
    trigger(name);
  }

  return (
    
    <div className="bg-white p-8 rounded-md">
    <form onSubmit={handleSubmit(createUser)}>
    <div className="flex justify-between items-stretch">
          <h2 className="text-base font-semibold leading-7 text-othergray-900 self-center">Create User</h2>
          {/* <p className="mt-1 text-sm leading-6 text-othergray-600">Update {data.email} info for {selectedClientName}.</p> */}
          <button className="cursor-pointer" onClick={closeModal}><XMarkIcon className="w-8 h-8 rounded-full stroke-othergray-900 "/></button>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 border-t border-othergray-900/10 pt-6"
          //  style={{display:'flex',width:'400px', flexDirection:'column'}}
           >
            <div className="sm:col-span-3">
              <label htmlFor="first-name" className="block text-sm font-medium leading-6 text-othergray-900">
                First name
              </label>
              <div className="mt-2">
                <input
                  style={{width:'100%'}}
                  {...register("firstName", { required: "First Name is required" })}
                  type="text"
                  name="firstName"
                  id="firstName"
                  autoComplete="none"
                  aria-invalid={errors?.firstName ? "true" : "false"} 
                  value={firstName}
                  // placeholder='Enter First Name'
                  onChange={(e) => {setFirstName(e.target.value); handleValidationChange(e.target.name, e.target.value)}}
                  className="block w-full rounded-md border-0 py-1.5 text-othergray-900 shadow-sm ring-1 ring-inset ring-othergray-300 placeholder:text-othergray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                />
                <p className="mt-2 text-sm text-red-600" id="firstNameError" style={{color:'red'}}>
                  {!!errors?.firstName && errors?.firstName?.message}
                </p>
              </div>
            </div>

            <div className="sm:col-span-3">
              <label htmlFor="last-name" className="block text-sm font-medium leading-6 text-othergray-900">
                Last name
              </label>
              <div className="mt-2">
                <input
                  style={{width:'100%'}}
                  {...register("lastName", { required: "Last Name is required" })}
                  type="text"
                  id="lastName"
                  name='lastName'
                  autoComplete='none'
                  label='Last Name'
                  value={lastName}
                  aria-invalid={errors?.lastName ? "true" : "false"} 
                  // placeholder='Enter Last Name'
                  onChange={(e) => {setLastName(e.target.value); handleValidationChange(e.target.name, e.target.value)}}
                  className="block w-full rounded-md border-0 py-1.5 text-othergray-900 shadow-sm ring-1 ring-inset ring-othergray-300 placeholder:text-othergray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                />
              </div>
              <p className="mt-2 text-sm text-red-600" id="lastNameError" style={{color:'red'}}>
                  {!!errors?.lastName && errors?.lastName?.message}
                </p>
            </div>

            <div className="sm:col-span-3">
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-othergray-900">
              Email address
              </label>
              <div className="mt-2">
                <input
                {...register("email", { required: 'Email is required', pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Please enter a valid email address'},
                  validate: value => validateNoDuplicates(value) || 'A user already exists with this email'
                  }) }
                  style={{width:'100%'}}
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="none"
                  value={email}
                  // placeholder='email@westloop.io'
                  onChange={(e) => {setEmail(e.currentTarget.value); handleValidationChange(e.currentTarget.name, e.currentTarget.value)}}
                  aria-invalid={errors?.email ? "true" : "false"} 
                  className="block w-full rounded-md border-0 py-1.5 text-othergray-900 shadow-sm ring-1 ring-inset ring-othergray-300 placeholder:text-othergray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                />
              </div>
              <p className="mt-2 text-sm text-red-600" id="emailError" style={{color:'red'}}>
                  {!!errors?.email && errors?.email?.message}
                </p>
            </div>

            <div className="sm:col-span-3">
              <label htmlFor="user-role" className="block text-sm font-medium leading-6 text-othergray-900">
                User Role
              </label>
              <div className="mt-2">
                <select
                  style={{width:'100%'}}
                  {...register("userRole", { required: 'Role is required', minLength: 1 })}
                  id="userRole"
                  placeholder='Select User Role'
                  value={role}
                  aria-invalid={errors?.userRole ? "true" : "false"} 
                  onChange={(e) => {setRole(e.target?.value); handleValidationChange(e.target?.name, e.target?.value)
                  }}
                  name='userRole'
                  className="block w-full rounded-md border-0 py-1.5 text-othergray-900 shadow-sm ring-1 ring-inset ring-othergray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:max-w-xs sm:text-sm sm:leading-6"
                >
                   <>
                    <option key='' value='' disabled={true} ></option>
                    <option key='ADMIN' value='ADMIN'>ADMIN</option>
                    <option key='USER' value='USER'>USER</option>
                  </>
                </select>
              </div>
            </div>

          </div>

          <div className="sm:col-start-2 sm:col-end-7 mt-6 flex items-center justify-between sm:justify-end gap-x-6">
          <button 
          type="button" 
          className="text-sm bg-othergray-200 font-semibold  text-othergray-900 px-3 py-2 rounded-md text-sm font-semibold shadow-sm hover:bg-othergray-400 hover:text-white"
          onClick={closeModal}
          disabled={working}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-200 disabled:bg-primary-200 focus-visible:outline-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          disabled={working}
        >
          Create User
        </button>
      </div>

      </form>
      </div>

  );
};

export default UserForm;